var _linearGradient, _path, _linearGradient2, _path2, _path3, _path4, _linearGradient3, _path5, _linearGradient4, _path6, _linearGradient5, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Language(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gCW9sGJUkBnBLRc40wQXGa",
    x1: 25.447,
    x2: 44.728,
    y1: 4.921,
    y2: 36.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42a3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42a4eb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gCW9sGJUkBnBLRc40wQXGa)",
    d: "M42,8H19l11,30h12c1.105,0,2-0.895,2-2V10C44,8.895,43.105,8,42,8z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gCW9sGJUkBnBLRc40wQXGb",
    x1: 3.865,
    x2: 23.412,
    y1: 9.86,
    y2: 41.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d59b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195bbc"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gCW9sGJUkBnBLRc40wQXGb)",
    d: "M19,8H6c-1.105,0-2,0.895-2,2v26c0,1.105,0.895,2,2,2h8v7.998 c0,0.891,1.077,1.337,1.707,0.707L24.412,38H30L19,8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12,25h6v2h-6V25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.109,29L15,20l2.906,9h2.11L16,17h-2l-4,12H12.109z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gCW9sGJUkBnBLRc40wQXGc",
    x1: 29.064,
    x2: 38.79,
    y1: 23.554,
    y2: 23.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11408a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103f8f"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gCW9sGJUkBnBLRc40wQXGc)",
    d: "M29.064,27.223c0.061-0.031,4.994-3.219,7.936-9.115L38.79,19 c-3.082,6.25-7.457,9.292-8.509,10L29.064,27.223z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gCW9sGJUkBnBLRc40wQXGd",
    x1: 28,
    x2: 40,
    y1: 23.5,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11408a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103f8f"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gCW9sGJUkBnBLRc40wQXGd)",
    d: "M38,29c0,0-5-2.583-7.769-6.998L32,21c2.333,3.833,6.981,6.26,6.981,6.26L38,29z M28,18h12v2 H28V18z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gCW9sGJUkBnBLRc40wQXGe",
    x1: 33,
    x2: 35,
    y1: 18,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11408a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103f8f"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gCW9sGJUkBnBLRc40wQXGe)",
    d: "M33,16h2v4h-2V16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Language);
export default __webpack_public_path__ + "static/media/icons8-language.fa9c8efe7ddf10458a8ec04298626ed5.svg";
export { ForwardRef as ReactComponent };